import { CheckDiscountCodePayload } from '@models/payload/discount';
import { DiscountResponse } from '@models/response/discount';
import { OrderingInitialState } from '@reducers/ordering/types';
import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { checkDiscountCode } from '@services/discount';
// eslint-disable-next-line import/no-cycle
import { createAppAsyncThunk } from '@utils/reduxUtil';

export const checkCouponCode = createAppAsyncThunk<
  DiscountResponse,
  CheckDiscountCodePayload & { networkStatus: boolean }
>('address/checkDiscountCode', async (payload) => {
  const response = await checkDiscountCode(payload);
  return response;
});

export const couponExtraReducers = (builder: ActionReducerMapBuilder<OrderingInitialState>) => {
  builder.addCase(checkCouponCode.pending, (state) => ({
    ...state,
    couponState: {
      ...state.couponState,
      loading: true,
    },
  }));
  builder.addCase(checkCouponCode.fulfilled, (state, action) => ({
    ...state,
    couponState: {
      ...state.couponState,
      loading: false,
      coupon: action.payload,
      couponCode: action.payload.data?.code || '',
    },
  }));
  builder.addCase(checkCouponCode.rejected, (state) => ({
    ...state,
    couponState: {
      ...state.couponState,
      loading: false,
    },
  }));
};
